// extracted by mini-css-extract-plugin
module.exports = {"fullHeightContainer":"HomePageSeedComponent_fullHeightContainer__2AWyB","flexRow":"HomePageSeedComponent_flexRow__2Lop7","staticRow":"HomePageSeedComponent_staticRow__1wTQg"};